'use client';

import type { CallbackAction } from '@fanduel/geolocation-sdk';

import { useStore } from '@/store/store';

/** postMessage type the embedded launcher listens for (mirrors the CustomEvent name). */
export const EMBEDDED_LAUNCHER_GEOLOCATION_RESULT = 'geolocationResult';

const dispatchToLauncherWindow = (detail: CallbackAction, launcherWindow: Window): void => {
    launcherWindow.postMessage({ type: EMBEDDED_LAUNCHER_GEOLOCATION_RESULT, detail }, window.location.origin);
};

/**
 * Mirrors native AndroidWrapper behaviour: lobby dispatches geolocationResult on the
 * embedded launcher window so launcher can forward GL/GEOLOCATION_RESULT to game-client.
 * No-ops when the iframe is not ready; game-client triggers locate when it is.
 */
export const dispatchGeolocationResultToEmbeddedLauncher = (detail: CallbackAction): boolean => {
    const { embeddedGame } = useStore.getState();
    if (!embeddedGame.isOpen) {
        return false;
    }

    const launcherWindow = embeddedGame.iframeRef?.contentWindow;
    if (!launcherWindow) {
        return false;
    }

    dispatchToLauncherWindow(detail, launcherWindow);
    return true;
};
